<template>
  <div class="container" v-if="RemenLuxianDetailData">
    <Header status="simple" />
    <RemenLuxian :RemenLuxianDetailData="RemenLuxianDetailData" />
  </div>
</template>

<script>
import Header from "@/components/Common/Header.vue";
import RemenLuxian from "@/components/RemenLuxian.vue";

export default {
  name: "ShengneiRemenLuxian",
  components: {
    Header,
    RemenLuxian
  },
  data() {
    return {
      RemenLuxianDetailData: null
      // cityList: [
      //   "郑州",
      //   "开封",
      //   "洛阳",
      //   "平顶山",
      //   "安阳",
      //   "鹤壁",
      //   "新乡",
      //   "焦作",
      //   "濮阳",
      //   "许昌",
      //   "漯河",
      //   "三门峡",
      //   "南阳",
      //   "商丘",
      //   "信阳",
      //   "周口",
      //   "驻马店"
      // ]
    };
  },
  computed: {
    // lineData() {
    //   let arr = [];
    //   for (let i = 0; i < 30; i++) {
    //     let temp = {
    //       name:
    //         this.cityList[this.randomFrom(0, this.cityList.length - 1)] +
    //         "->" +
    //         this.cityList[this.randomFrom(0, this.cityList.length - 1)] +
    //         "->" +
    //         this.cityList[this.randomFrom(0, this.cityList.length - 1)],
    //       hot: this.randomFrom(0, 10000),
    //       line: [
    //         113.79 + Math.random() * 5 + "," + (33.8 + Math.random() * 3),
    //         113.79 + Math.random() * 4 + "," + (33.8 + Math.random() * 2),
    //         113.79 + Math.random() * 3 + "," + (33.8 + Math.random() * 1)
    //       ]
    //     };
    //     arr.push(temp);
    //   }
    //   arr.sort((a, b) => {
    //     return b.hot - a.hot;
    //   });
    //   return arr;
    // }
  },
  mounted() {
    // 请求地图数据
    fetch("/data/Home/RemenLuxianDetail.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.RemenLuxianDetailData = json.data;
      });
  },
  methods: {}
};
</script>
<style scoped lang="less"></style>
